import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=01ac0d92"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style0 from "./orderList.vue?vue&type=style&index=0&id=01ac0d92&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ac0d92')) {
      api.createRecord('01ac0d92', component.options)
    } else {
      api.reload('01ac0d92', component.options)
    }
    module.hot.accept("./orderList.vue?vue&type=template&id=01ac0d92", function () {
      api.rerender('01ac0d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/orderList.vue"
export default component.exports